import { createStyles, keyframes } from '@mantine/emotion';

const dotBounce = keyframes({
  '0%, 80%, 100%': { transform: 'scale(0)' },
  '40%': { transform: 'scale(1)' },
});

export const useChatStyles = createStyles((theme, _, u) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  userHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    borderBottom: theme.other.elements.appBorder,
    flex: '0 0 auto',
  },
  messagesWrap: {
    flex: 1,
    minHeight: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  robotWatermark: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    color: theme.colors.teal[6],
    opacity: 0.16,
    [u.dark]: { opacity: 0.22 },
  },
  messages: {
    flex: 1,
    position: 'relative',
    overflowY: 'auto',
    padding: theme.spacing.md,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.sm,
  },
  userMessage: {
    alignSelf: 'flex-end',
    maxWidth: '75%',
    backgroundColor: theme.colors.teal[6],
    color: theme.white,
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.radius.md,
    borderBottomRightRadius: 2,
    fontSize: theme.fontSizes.sm,
    whiteSpace: 'pre-wrap',
  },
  assistantMessageWrap: {
    alignSelf: 'flex-start',
    maxWidth: '75%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,

    '&:hover [data-rating-actions]': {
      opacity: 1,
    },
  },
  assistantMessage: {
    backgroundColor: theme.colors.gray[0],
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.radius.md,
    borderBottomLeftRadius: 2,
    fontSize: theme.fontSizes.sm,

    '& .wmde-markdown': {
      backgroundColor: 'transparent',
      fontSize: theme.fontSizes.sm,
    },

    [u.dark]: { backgroundColor: theme.colors.dark[5] },
  },
  ratingActions: {
    display: 'flex',
    gap: 2,
    alignSelf: 'flex-end',
    paddingRight: 4,
    opacity: 0,
    transition: 'opacity 120ms',

    '&[data-rated="true"]': {
      opacity: 1,
    },
  },
  inputArea: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing.xs,
    padding: theme.spacing.md,
    borderTop: theme.other.elements.appBorder,
    flex: '0 0 auto',
  },
  typingDots: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    alignSelf: 'flex-start',

    '& span': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: theme.colors.gray[4],
      display: 'inline-block',
      animation: `${dotBounce} 1.4s infinite ease-in-out both`,
    },
    '& span:nth-of-type(1)': { animationDelay: '-0.32s' },
    '& span:nth-of-type(2)': { animationDelay: '-0.16s' },
  },
}));
